module.exports = __webpack_public_path__ + "img/thumb_10.cb78b06b.jpg";